// @flow
import React, { Component } from 'react';
import RequiresAction from './RequiresAction';
import { Device } from '../../../components/Responsive';

type Props = {
  currencyName: string,
  currencyType: string,
  requiresCryptoWallet: boolean,
  requiresBankAccount: boolean
};

export default class RequiresActionMobile extends Component<Props> {
  render() {
    return (
      <Device>
        <RequiresAction
          currencyName={this.props.currencyName}
          currencyType={this.props.currencyType}
          requiresCryptoWallet={this.props.requiresCryptoWallet}
          requiresBankAccount={this.props.requiresBankAccount}
        />
      </Device>
    );
  }
}
